import React from "react";
// import avitar from "../avitar.png"   you can import or use require
import "../collaboration.css";

export default function Collaboration() {
  return (
    <div className="collaboration"> 
    
    <div>
      <img className="avitarC" src={require("../images/avitar.jpg")} alt="pic" />
      </div>
      <p className="titleC">Collaboration is a great way to expand your knowledge base. <br></br>
      Creating a network will get you to your goals.<br></br>
      This will hone yourskills.<br></br>
      Working with teams or collaborations is how we excel at what we do.<br></br> 
      I would love to participate in your project as Freelance or Conntract.</p>
     
      
      <div className="deelake">
      <a href="https://dee-lake-wilderness--iec3.glide.page/dl/a400f7" target="blank">Dee Lake Wilderness App</a>;
      </div>
    </div>
  );
}
